import { styled } from 'linaria/react';
import React from 'react';
import theme from 'clad-ui/theme/chotot';
import Image from 'next/image';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1in6re8"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "tizvzr8"
});
const Desc = /*#__PURE__*/styled("div")({
  name: "Desc",
  class: "dgtivv6"
});
const Item = /*#__PURE__*/styled("li")({
  name: "Item",
  class: "i1ksfm3y"
});
const CategoryText = /*#__PURE__*/styled("span")({
  name: "CategoryText",
  class: "cy7thji"
});
const CategorySubText = /*#__PURE__*/styled("span")({
  name: "CategorySubText",
  class: "cf00hpr"
});
const WrapperCat = /*#__PURE__*/styled("div")({
  name: "WrapperCat",
  class: "w1qh49r2"
});
const Text = /*#__PURE__*/styled("div")({
  name: "Text",
  class: "ti3lcjf"
});
const ImgParent = /*#__PURE__*/styled("div")({
  name: "ImgParent",
  class: "i1645ew3"
});
const CategoryImg = /*#__PURE__*/styled("div")({
  name: "CategoryImg",
  class: "co3c0i8"
});
const ImgLogo = /*#__PURE__*/styled("img")({
  name: "ImgLogo",
  class: "i5lcad7"
});
const Services = ({
  services = [],
  description = '',
  onClick,
  isDone
}) => {
  return isDone && services.length > 0 ? <Wrapper onClick={() => onClick()}>
      <Title>
        Giới thiệu{' '}
        <ImgLogo src="https://static.chotot.com/storage/default_images/job_introduce.png" alt="job_introduce" />
      </Title>
      <Desc dangerouslySetInnerHTML={{
      __html: description
    }} />
      <WrapperCat>
        {services.map((item, index) => {
        // const regionString = `${regionLocation.regionUrl}${regionLocation.subRegionUrl ? '/' + regionLocation.subRegionUrl : ''
        //   }${regionLocation.wardUrl ? '/' + regionLocation.wardUrl : ''}`;
        // const url = `${item.use_local_region
        //   ? item.web_url.replace(DEFAULT_LOCATION, regionString)
        //   : item.web_url
        //   }`;
        item.index = index;
        return <Item key={'cat-' + index.toString()}>
              {/* <A aria-label={item.text} href={url}> */}
              <ImgParent>
                <CategoryImg>
                  <Image src={item.image} alt={'cat-' + index.toString()} width={68} height={68} loading="lazy" />
                </CategoryImg>
              </ImgParent>
              <Text>
                <CategoryText>{item.text || ''}</CategoryText>
                <CategorySubText>{item.sub_text || ''}</CategorySubText>
              </Text>
              {/* </A> */}
            </Item>;
      })}
      </WrapperCat>
    </Wrapper> : null;
};
export default Services;

require("../../../.linaria-cache/src/components/Services/index.linaria.module.css");